import type { FormSelectOption } from '@practium/ui';
import { FoliarFormData, FoliarProductFormData } from '../types';

export const PRODUCT_COMMERCIAL_OPTIONS: Record<string, FormSelectOption[]> = {
	Fertilizante: [
		{ value: 'Formulado 24-10-10', label: 'Formulado 24-10-10' },
		{ value: 'Cloreto de Potássio', label: 'Cloreto de Potássio' },
		{ value: 'Nitrato de Magnésio', label: 'Nitrato de Magnésio' },
		{ value: 'Quelato de Cobre', label: 'Quelato de Cobre' },
		{ value: 'Ureia', label: 'Ureia' },
	],
	Defensivo: [
		{ value: 'Score 250 EC', label: 'Score 250 EC' },
		{ value: 'Priori Xtra', label: 'Priori Xtra' },
	],
	Micronutriente: [
		{ value: 'Boro Foliar', label: 'Boro Foliar' },
		{ value: 'Zinco Foliar', label: 'Zinco Foliar' },
	],
	Regulador: [{ value: 'Stimulate', label: 'Stimulate' }],
};

export const BRAND_OPTIONS: FormSelectOption[] = [
	{ value: 'Genérico', label: 'Genérico' },
	{ value: 'Syngenta', label: 'Syngenta' },
	{ value: 'Bayer', label: 'Bayer' },
	{ value: 'Corteva', label: 'Corteva' },
];

export const CULTURE_OPTIONS: FormSelectOption[] = [
	{ value: 'cafeArabica', label: 'Café Arábica' },
	{ value: 'cafeConilon', label: 'Café Conilon' },
];

export const DOSE_UNIT_OPTIONS: FormSelectOption[] = [
	{ value: '/ha', label: 'kg/ha' },
	{ value: '/100L', label: 'kg/100L' },
];

export const PRODUCT_CLASS_OPTIONS: FormSelectOption[] = [
	{ value: 'Fertilizante', label: 'Fertilizante' },
	{ value: 'Defensivo', label: 'Defensivo' },
	{ value: 'Micronutriente', label: 'Micronutriente' },
	{ value: 'Regulador', label: 'Regulador' },
];

export const DEFAULT_FOLIAR_PRODUCT: FoliarProductFormData = {
	productClass: '',
	productCommercialName: '',
	productTradeMark: '',
	dose: '',
	doseMeasurementUnit: '',
};

export const DEFAULT_FOLIAR_FORM: FoliarFormData = {
	name: '',
	prop: '',
	area: '',
	sectors: [],
	applicationDate: '',
	tankVolume: 0,
	syrupVolume: 0,
	tanksToPrepare: 0,
	products: [DEFAULT_FOLIAR_PRODUCT],
};
